/**
 * Navigation utilities for handling redirects outside of React components
 */

/**
 * Redirects to login page and clears any error states
 * Can be called from anywhere, including error handlers
 */
export function redirectToLogin(): void {
  // Don't redirect if already on login (home) or register page (prevent redirect loop)
  const currentPath = window.location.pathname;
  if (currentPath === '/' || currentPath === '/register') {
    return;
  }
  
  // Store current path for redirect after login
  sessionStorage.setItem('redirectAfterLogin', currentPath);
  
  // Redirect to login (home page)
  window.location.href = '/';
}

/**
 * Gets the stored redirect path and clears it
 */
export function getAndClearRedirectPath(): string | null {
  const path = sessionStorage.getItem('redirectAfterLogin');
  sessionStorage.removeItem('redirectAfterLogin');
  return path;
}

